import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useI18n } from '../../../../context/occ/hooks/use-i18n';
import { useFieldValidator } from '../../../../hooks/use-field-validator';
import { getFormFieldErrorMessage } from '../../form-field-utils';
import { CheckboxInput } from '../../input/checkbox/checkbox-input';
import { Field } from '../field/field';
import { getFieldProps } from '../utils/get-field-props';
import { isCheckboxFieldWithHelpTextProps } from './types/props';
const b = bemClassBuilder('v-checkbox-field');
export const CheckboxField = observer(props => {
    const i18n = useI18n();
    const { name, value, displayText, validate, onChangeValue, setHelpText } = props;
    const errorMessage = isCheckboxFieldWithHelpTextProps(props)
        ? getFormFieldErrorMessage(props.error, displayText, i18n)
        : undefined;
    const { onValueChangedValidation } = useFieldValidator(validate || (() => Promise.resolve(undefined)), // 'validate' is optional, so just pass validation if not provided.
    setHelpText, errorMessage);
    const handleValueChanged = (newValue) => {
        onChangeValue === null || onChangeValue === void 0 ? void 0 : onChangeValue(newValue);
        onValueChangedValidation(newValue, !!errorMessage);
    };
    const fieldProps = getFieldProps(Object.assign(Object.assign({}, props), { b, helpText: errorMessage }));
    return (_jsx(Field, Object.assign({}, fieldProps, { children: _jsx(CheckboxInput, Object.assign({}, props, { className: undefined, value: value, optionValue: name, onChangeValue: handleValueChanged })) })));
});
CheckboxField.displayName = 'CheckboxField';
